import React from 'react';
import { Section } from './ui/Section';
export function PatternInterrupt() {
  return <Section className="text-center" data-id="element-61">
      <div className="max-w-3xl mx-auto space-y-12" data-id="element-62">
        <h2 className="font-serif text-3xl md:text-5xl leading-tight text-white" data-id="element-63">
          The truth most online courses <br data-id="element-64" />
          <span className="text-luxury-gold italic" data-id="element-65">won’t tell you</span>
        </h2>

        <div className="w-px h-16 bg-gradient-to-b from-transparent via-luxury-gold to-transparent mx-auto" data-id="element-66" />

        <div className="space-y-6 text-lg md:text-xl font-light text-luxury-gray leading-relaxed" data-id="element-67">
          <p data-id="element-68">Most women online chase visibility.</p>
          <p data-id="element-69">They copy trends.</p>
          <p data-id="element-70">They wait for confidence.</p>
          <p data-id="element-71">They hope something goes viral.</p>
          <p className="text-white font-medium" data-id="element-72">Then they burn out.</p>
        </div>

        <div className="p-8 border border-luxury-gold/20 bg-luxury-charcoal/30 mt-8" data-id="element-73">
          <p className="text-xl md:text-2xl text-white font-serif italic mb-4" data-id="element-74">
            "Income online is not built on attention. It’s built on
            positioning."
          </p>
          <p className="text-luxury-gray" data-id="element-75">
            My growth wasn’t luck. It was structure.
          </p>
        </div>
      </div>
    </Section>;
}